import { render, staticRenderFns } from "./OrdersCostsAmazon.vue?vue&type=template&id=b1bf7096"
import script from "./OrdersCostsAmazon.vue?vue&type=script&lang=js"
export * from "./OrdersCostsAmazon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports